(function () {
  // NaE Design — correctif accessibilite "aria-hidden-focus"
  // Empeche le focus clavier sur les liens/boutons contenus dans des elements
  // aria-hidden="true" (slides de carrousel masquees, widget d'avis Judge.me).
  // N'agit QUE sur le focus clavier : aucun changement visuel, le clic souris fonctionne.

  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function scan() {
    // 1) Neutralise les elements focusables dans les conteneurs masques
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
      el.querySelectorAll(FOCUSABLE).forEach(function (node) {
        if (!node.hasAttribute('data-nae-tabindex')) {
          node.setAttribute('data-nae-tabindex', node.getAttribute('tabindex') || '');
          node.setAttribute('tabindex', '-1');
        }
      });
    });
    // 2) Restaure ceux qui ne sont plus masques (slide redevenue active, etc.)
    document.querySelectorAll('[data-nae-tabindex]').forEach(function (node) {
      if (!node.closest('[aria-hidden="true"]')) {
        var orig = node.getAttribute('data-nae-tabindex');
        if (orig === '') node.removeAttribute('tabindex');
        else node.setAttribute('tabindex', orig);
        node.removeAttribute('data-nae-tabindex');
      }
    });
  }

  var scheduled = false;
  function run() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Re-passe a chaque rotation de carrousel et a l'injection tardive de Judge.me
  new MutationObserver(run).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
})();